import { css } from '@emotion/react';
import { forwardRef, PropsWithChildren } from 'react';

import { theme } from '../theme';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    font-size: ${theme.fontSize.sm};
  `,
  title: css`
    font-weight: ${theme.fontWeight.black};
    color: ${theme.colors.blue[2]};
    font-size: ${theme.fontSize.xs};
    padding-bottom: ${theme.spacing.xs};
    white-space: nowrap;
  `,
};

type Props = PropsWithChildren<{ title?: string; className?: string }>;

export const LegacyCartItem = forwardRef<HTMLDivElement, Props>(({ title, children, className }, ref) => (
  <div css={styles.container} className={className} ref={ref}>
    <h4 css={styles.title}>{title ?? ''}</h4>
    {children}
  </div>
));

LegacyCartItem.displayName = 'LegacyCartItem';
